import { generatePath as generatePathRaw } from 'react-router-dom';
import { FIRST_NUMERIC_URL_PARAMETER_REGEX, isAbsoluteUrl } from '.';
import { getWorkspaceAliasFromUrl } from './workspace';

export const generatePath: typeof generatePathRaw = (path, params) => {
    const workspaceAlias = getWorkspaceAliasFromUrl();
    const newParams = workspaceAlias
        ? ({
              workspaceAlias: workspaceAlias,
              ...params,
          } as unknown as typeof params)
        : params;

    const queryString = path.match(/\?([^?]*?=.*)$/);

    const newPath = queryString ? path.replace(queryString[0], '') : path;

    return (
        generatePathRaw(newPath, newParams) +
        (queryString ? queryString[0] : '')
    );
};

export const generatePathWithoutWorkspaceAlias = (path: string): string => {
    return generatePathRaw(path, {});
};

export const generatePathOrReturnAbsoluteLink = (url: string): string => {
    return isAbsoluteUrl(url) ? url : generatePath(url);
};

export const getRedirectUrlWithWorkspaceAlias = (
    workspaceAlias: number
): string => {
    if (window.location.pathname.match(FIRST_NUMERIC_URL_PARAMETER_REGEX)) {
        return window.location.pathname;
    }
    return (
        '/' +
        workspaceAlias.toString() +
        window.location.pathname +
        window.location.search
    );
};

export const redirectToUrlWithWorkspaceAlias = (
    workspaceAlias: number
): void => {
    window.location.pathname = getRedirectUrlWithWorkspaceAlias(workspaceAlias);
};
